import createIcon from '../../createIcon';

/**
 * @component @name MergeType
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuOTk5OCAyMC40NTQ5TDE4LjQwOTggMTkuMDQ0OUwxNC45OTk4IDE1LjYzNDlMMTMuNTg5OCAxNy4wNDQ5TDE2Ljk5OTggMjAuNDU0OVpNNy40OTk4NCA4LjA0NDkySDEwLjk5OThWMTMuNjM0OUw1LjU4OTg0IDE5LjA0NDlMNi45OTk4NCAyMC40NTQ5TDEyLjk5OTggMTQuNDU0OVY4LjA0NDkySDE2LjQ5OThMMTEuOTk5OCAzLjU0NDkyTDcuNDk5ODQgOC4wNDQ5MloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MergeType = createIcon('MergeType', [
  [
    'path',
    {
      d: 'M16.9998 20.4549L18.4098 19.0449L14.9998 15.6349L13.5898 17.0449L16.9998 20.4549ZM7.49984 8.04492H10.9998V13.6349L5.58984 19.0449L6.99984 20.4549L12.9998 14.4549V8.04492H16.4998L11.9998 3.54492L7.49984 8.04492Z',
      key: 'yxplrc',
    },
  ],
]);

export default MergeType;
